import React,{ useEffect, useState } from "react";
import "./user.css";
import { useSelector } from 'react-redux';
import { ensureStageSessionForUser } from '../../functions/stageReportSync';
import { useLocation } from "react-router-dom";

function USER({children }) {
    const location = useLocation();

    const {companyLogoUrl,backButtonUrl} = useSelector(state => state.ui);
    const [logoUrl,setLogoUrl]=useState("");
    const [backUrl,setBackUrl]=useState("");

    const { user } = useSelector(state => state.auth);
    const fromMobileAppInUrl =
      String(new URLSearchParams(location.search).get("fromMobileApp") || "").toLowerCase() ===
      "true";
    const fromMobileAppInUser = String(user?.fromMobileApp || "").toLowerCase() === "true";
    const persistedFromMobileApp = (() => {
      try {
        const persisted = JSON.parse(
          sessionStorage.getItem("userData") || "{}"
        );
        return String(persisted?.fromMobileApp || "").toLowerCase() === "true";
      } catch {
        return false;
      }
    })();
    const isFromMobileApp = fromMobileAppInUrl || fromMobileAppInUser || persistedFromMobileApp;
  const userKey = user?.userId || user?.userid || user?.id;
  useEffect(() => {
    try {
      const storedUser = user || JSON.parse(sessionStorage.getItem("userData") || "{}");
      ensureStageSessionForUser(storedUser);
    } catch {
      /* ignore */
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userKey]);

  useEffect(()=>{
    setBackUrl(backButtonUrl);
    setLogoUrl(companyLogoUrl);
  },[backButtonUrl,companyLogoUrl])

  const handleLogoClick = (e) => {
    if (!isFromMobileApp) return;
    e.preventDefault();
    window.GameStatus?.postMessage?.("navigate_back");
  };

  const handleBackClick = (e) => {
    if (!backUrl) {
      e.preventDefault();
      return;
    }
    const current =
      window.location.pathname + window.location.search + window.location.hash;
    if (backUrl === current) {
      e.preventDefault();
    }
  };

  const backHref = backUrl || "#";

  return (
    <>
      <header className="upperaction">
      <a href={process.env.REACT_APP_BASE_URL} onClick={handleLogoClick}><img src={logoUrl} className="logo-holder" alt="" /></a>
        {!isFromMobileApp && (
          <div className="back-holder">
            <a
              href={backHref}
              onClick={handleBackClick}
            >
              <button type="button" className="back-default">
                Back
              </button>
            </a>
          </div>
        )}

      </header>
      {children}
    </>
  );
}

export default USER;
